import {useEffect} from 'react'

const SIDE_PANEL_CONTENT_ID = 'issue-viewer-side-panel'

/**
 * Resets the scroll position of the side panel to the top
 * when the issue identity changes inside a side panel.
 *
 * Firefox preserves the scroll position of overflow containers across re-renders,
 * causing a new issue to appear scrolled partway down.
 */
export function useSidePanelScrollReset(
  insideSidePanel: boolean | undefined,
  owner: string,
  repo: string,
  number: number,
) {
  useEffect(() => {
    if (!insideSidePanel) return

    // Defer the scroll reset to the next animation frame to avoid
    // interleaving layout reads/writes in the same task.
    const frameId = requestAnimationFrame(() => {
      // The side panel content div is always mounted when insideSidePanel is true.
      // Its parent is the SidePanel's scrollable container (overflow: auto).
      const content = document.getElementById(SIDE_PANEL_CONTENT_ID)
      const scrollable = content?.parentElement
      if (scrollable) {
        scrollable.scrollTop = 0
      }
    })

    return () => cancelAnimationFrame(frameId)
  }, [owner, repo, number, insideSidePanel])
}
